import '../../App.css';
import React from 'react';
import moment from 'moment';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Table, Row, Col } from 'reactstrap';
import { DefaultAjax, modalForbidden } from "../../components/DefaultAjax";
import i18n from "i18n-react";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import DefaultModal from '../../components/DefaultModal';
import DefaultSpinner from '../../components/DefaultSpinner';
import { Tooltip as ReactTooltip } from 'react-tooltip';

class AppInstallAudit extends React.Component {
    constructor(props){
        super(props);
        this.state={
            spinner:"",
            modalContent:"",
            listAudit: [],
            listSearchAudit: [], 
            servicesList: [],
            selectedServiceId:0,
            startDate: moment().add(-12, 'hour'),
            endDate: moment().add(12, 'hour'), 
            dateRange:[],
            probingDeviceId:"",
            savingProbeConfig:false,
            probeConfig:{
                enabled:true,
                intervalHours:6,
                lastRunDate:"",
                nextRunDate:""
            },
        } 
        this.state.dateRange.push(this.dateRangeForSearh(new Date(moment().add(-12, 'hour'))));
        this.state.dateRange.push(this.dateRangeForSearh(new Date(moment().add(12, 'hour'))));
    } 

    componentDidMount(){
        this.getListApp();
        this.getServices();
        this.getProbeConfig();
        let nav = document.querySelector("#nav-top").offsetHeight;
        let navbar = document.querySelector(".navbarT").offsetHeight;
        let altura = window.innerHeight - nav - navbar - 50;
        let bodyContent = document.querySelector("#bodyContent");
        bodyContent.style.maxHeight = altura + "px";
    }

    dateRangeForSearh = (date) => {
        let startDate = new Date(date);
        let m = startDate.getMonth() + 1;
        let mes = (m < 10) ? '0' + m : m;
        let day = startDate.getDate();
        let dayForShow = (day < 10) ? '0' + day : day;
        startDate = dayForShow+"-"+mes+"-"+startDate.getFullYear();
        return startDate;
    }

    filterAppList = e =>{
        let filterSearch = e.target.value.toLowerCase();

        let searchRes = this.state.listAudit.filter((e) => {
            let username = e.username.toLowerCase();
            let serviceName = e.serviceName.toString();
            let fullname = e.fullname.toString();
            let deviceId = e.deviceId ? e.deviceId.toString().toLowerCase() : "";
            let appStatus = e.appStatus ? e.appStatus.toString().toLowerCase() : "";
            return username.indexOf(filterSearch) !== -1 || serviceName.indexOf(filterSearch) !== -1 || fullname.indexOf(filterSearch) !== -1 || deviceId.indexOf(filterSearch) !== -1 || appStatus.indexOf(filterSearch) !== -1
        })
        if(e.target.value === ''){
            searchRes = this.state.listSearchAudit;
        }
        this.setState({listAudit:searchRes});
    } 

    getListApp = (showAll) =>{
        
        let startDate = this.state.dateRange[0];
        let endDate = this.state.dateRange[1];
        if(showAll){
            startDate = "";
            endDate = "";
        } 

        DefaultAjax('').get("/installAppAudit?startDate="+startDate+"&endDate="+endDate+"&serviceId="+this.state.selectedServiceId)
        .then((res) =>{
            if(res){
                let result = JSON.parse(res.data);
                this.setState({
                    listAudit:result,
                    listSearchAudit:result
                })
            } 
        }).catch((error) =>{
            this.setState({
                modalContent:"",
                spinner:"",
                component:error.message
            });
            if (error.response) {
                if(error.response.status === 403){
                    setTimeout(()=> { 
                        this.setState({modalContent:modalForbidden()});
                    }, 10);
                } 
            }
        });
    } 

    getServices = () =>{
        DefaultAjax('').get("/installAppAudit/services")
        .then((res) =>{
            if(res){
                let result = typeof res.data === "string" ? JSON.parse(res.data) : res.data;
                this.setState({servicesList:result});
            }
        }).catch((error) =>{
            this.handleRequestError(error);
        });
    }

    handleServiceChange = (event) => {
        this.setState({selectedServiceId:parseInt(event.target.value, 10)});
    }

    getProbeConfig = () =>{
        DefaultAjax('').get("/installAppAudit/probeConfig")
        .then((res) =>{
            if(res){
                let result = typeof res.data === "string" ? JSON.parse(res.data) : res.data;
                this.setState({
                    probeConfig:{
                        enabled:result.enabled,
                        intervalHours:result.intervalHours,
                        lastRunDate:result.lastRunDate,
                        nextRunDate:result.nextRunDate
                    }
                })
            }
        }).catch((error) =>{
            this.handleRequestError(error);
        });
    }

    handleProbeConfigChange = (event) => {
        let name = event.target.name;
        let checked = event.target.checked;
        let value = event.target.value;

        this.setState((previousState) => {
            let probeConfig = {...previousState.probeConfig};
            if(name === "enabled"){
                probeConfig.enabled = checked;
            }else if(name === "intervalHours"){
                probeConfig.intervalHours = parseInt(value, 10);
            }
            return {probeConfig:probeConfig};
        });
    }

    saveProbeConfig = () => {
        let spinner = this.getSpinner();

        this.setState({
            savingProbeConfig:true,
            spinner:spinner
        });

        DefaultAjax('').post("/installAppAudit/probeConfig", this.state.probeConfig)
        .then((res) =>{
            let result = typeof res.data === "string" ? JSON.parse(res.data) : res.data;
            let buttons = [{text: i18n.translate("default_close"), function: ""}];
            this.setState({probeConfig:result});
            this.showModal(i18n.translate("automatic_fcm_probe_config"), i18n.translate("automatic_fcm_probe_config_saved"), buttons);
            this.getListApp();
        }).catch((error) =>{
            this.handleRequestError(error);
        }).finally(() => {
            this.setState({
                savingProbeConfig:false,
                spinner:""
            });
        });
    }

    showAppDetail = (app) => {
        let modalContent = this.getDetailContent(app);
        let buttons = [{text: i18n.translate("default_close"), function: ""}];

        this.showModal(i18n.translate("default_details"), modalContent, buttons);
    }
    
    getDetailContent = (app) => {
        return(
            <>
                {app.detail.map((detail) => {
                    return(
                        <>
                            <Row style={{paddingTop:'10px'}}>
                                <Col style={{fontWeight:'bolder'}}>
                                    {i18n.translate("event_date")} 
                                </Col>
                                <Col>
                                    {detail.eventDate} 
                                </Col>
                            </Row>
                            <Row>
                                <Col style={{fontWeight:'bolder'}}>
                                    {i18n.translate("event_type")} 
                                </Col>
                                <Col>
                                    {this.getEventType(detail.eventType)}
                                </Col>
                            </Row>
                            <Row style={{paddingBottom:'10px',borderBottom:'1px solid gray'}}>
                                <Col style={{fontWeight:'bolder'}}>
                                    {i18n.translate("show_notification")} 
                                </Col>
                                <Col>
                                    {detail.showNotification} 
                                </Col>
                            </Row> 
                        </>
                    )
                })}
            </>
        )
    } 

    handleCallback = (start, end, label) => {
        this.setState({dateRange:""})
        let dateRange = []; 
        dateRange.push(this.dateRangeForSearh(start._d));
        dateRange.push(this.dateRangeForSearh(end._d));
        this.setState({
            dateRange:dateRange,
            startDate: start._d,
            endDate:end._d
        });
    }

    getValue = (value) => {
        if(value === 0){
            return 0;
        }
        return value || "";
    }

    getStatus = (status) => {
        return status ? String(i18n.translate(status)) : "";
    }

    getEventType = (eventType) => {
        if(!eventType){
            return "";
        }
        if(eventType.indexOf("fcm_probe_error_") === 0){
            return String(i18n.translate("fcm_probe_error"))+" ("+eventType.replace("fcm_probe_error_", "")+")";
        }
        if(eventType.indexOf("reactivation_notification_error_") === 0){
            return String(i18n.translate("reactivation_notification_error"))+" ("+eventType.replace("reactivation_notification_error_", "")+")";
        }
        return String(i18n.translate(eventType));
    }

    getFirebaseToken = (token) => {
        if(!token){
            return "";
        }
        if(token.length <= 16){
            return token;
        }
        return token.substring(0, 8)+"..."+token.substring(token.length - 6);
    }

    getHeaderWithHelp = (titleKey, helpKey) => {
        let tooltipId = "app-install-audit-help-"+helpKey;

        return(
            <>
                {i18n.translate(titleKey)}
                <ReactTooltip id={tooltipId} place="top" effect="solid"/>
                <span
                    data-tooltip-id={tooltipId}
                    data-tooltip-content={i18n.translate(helpKey)}
                    style={{
                        display:'inline-block',
                        marginLeft:'5px',
                        width:'16px',
                        height:'16px',
                        lineHeight:'16px',
                        borderRadius:'50%',
                        border:'1px solid #666',
                        textAlign:'center',
                        fontSize:'11px',
                        cursor:'help',
                        backgroundColor:'#f5f5f5',
                        color:'#333'
                    }}>
                    ?
                </span>
            </>
        )
    }

    getSelectStyle = () => {
        return {
            height:'27px',
            lineHeight:'27px',
            paddingTop:'0px',
            paddingBottom:'0px',
            fontSize:'12px'
        }
    }

    showModal = (title, content, buttons) => {
        this.setState({modalContent:""});
        setTimeout(()=> {
            this.setState({modalContent:<DefaultModal show={true} title={title} content={content} buttons={buttons}/>});
        }, 10);
    }

    sendFcmProbe = (app, event) => {
        event.stopPropagation();

        if(!app.deviceId){
            return;
        }

        let spinner = this.getSpinner();

        this.setState({
            probingDeviceId:app.deviceId,
            spinner:spinner
        });
        DefaultAjax('').post("/installAppAudit/probe", {id: app.id, deviceId: app.deviceId})
        .then((res) =>{
            let result = res.data;
            let buttons = [{text: i18n.translate("default_close"), function: ""}];
            this.showModal(i18n.translate("manual_fcm_probe"), this.getEventType(result), buttons);
            this.getListApp();
        }).catch((error) =>{
            this.handleRequestError(error);
        }).finally(() => {
            this.setState({
                probingDeviceId:"",
                spinner:""
            });
        });
    }

    sendReactivationNotification = (app, event) => {
        event.stopPropagation();

        if(!app.deviceId){
            return;
        }

        let spinner = this.getSpinner();

        this.setState({
            probingDeviceId:app.deviceId,
            spinner:spinner
        });
        DefaultAjax('').post("/installAppAudit/reactivationNotification", {id: app.id, deviceId: app.deviceId})
        .then((res) =>{
            let result = res.data;
            let buttons = [{text: i18n.translate("default_close"), function: ""}];
            this.showModal(i18n.translate("send_reactivation_notification"), this.getEventType(result), buttons);
            this.getListApp();
        }).catch((error) =>{
            this.handleRequestError(error);
        }).finally(() => {
            this.setState({
                probingDeviceId:"",
                spinner:""
            });
        });
    }

    getSpinner = () => {
        let instanceTypeInput = document.querySelector("#instanceType");
        let independentInput = document.querySelector("#independent");
        let instanceType = instanceTypeInput ? instanceTypeInput.value : "";
        let independent = independentInput ? independentInput.value : "";

        return <DefaultSpinner instanceType={instanceType} independent={independent} />;
    }

    handleRequestError = (error) => {
        this.setState({
            modalContent:"",
            spinner:"",
            component:error.message
        });
        if (error.response) {
            if(error.response.status === 403){
                setTimeout(()=> {
                    this.setState({modalContent:modalForbidden()});
                }, 10);
            }
        }
    }

    render(){
        return (
            <>
                {this.state.modalContent} 
                <br/>
                <nav className='navbarT'>
                    <Row>
                        <Col sm={12} md={3} lg={3} xl={3}>
                            <label>{i18n.translate("default_search")}</label>
                            <input className="form-control inputStandard" type='text' onChange={this.filterAppList}/>
                        </Col>
                        <Col sm={12} md={3} lg={3} xl={3} style={{paddingTop:'5px'}}>
                            <label>{i18n.translate("installation_date")}</label>
                            <DateRangePicker
                                initialSettings={{ startDate: this.state.startDate, endDate: this.state.endDate }}
                                onCallback={this.handleCallback}
                            >
                                <input type="text" readOnly style={{fontSize: "12px",padding: "5px",cursor:"pointer"}} className="form-control inputStandard" />
                            </DateRangePicker>
                        </Col>
                        <Col sm={12} md={3} lg={3} xl={3} style={{paddingTop:'5px'}}>
                            <label>{i18n.translate("default_service")}</label>
                            <select
                                className="form-select inputStandard"
                                style={this.getSelectStyle()}
                                value={this.state.selectedServiceId}
                                onChange={this.handleServiceChange}>
                                <option value={0}>{i18n.translate("default_all")}</option>
                                {this.state.servicesList.map((service) => {
                                    return(
                                        <option value={service.serviceId} key={service.serviceId}>
                                            {service.serviceId} - {service.name}
                                        </option>
                                    )
                                })}
                            </select>
                        </Col>
                        <Col sm={12} md={3} lg={3} xl={3} style={{paddingTop:'15px'}}>
                            <button style={{float: 'right'}} className='buttonMzateSecondary' onClick={()=>this.getListApp(true)}>{i18n.translate("default_show_all")}</button>
                            {''}
                            <button style={{float: 'right',marginRight: '10px'}} className='buttonMzateSecondary' onClick={()=>this.getListApp()}>{i18n.translate("default_search")}</button>
                        </Col>
                    </Row>
                    <Row style={{marginTop:'10px', borderTop:'1px solid #ddd', paddingTop:'10px'}}>
                        <Col sm={12} md={2} lg={2} xl={2}>
                            <label>{i18n.translate("automatic_fcm_probe")}</label>
                            <div>
                                <input
                                    type="checkbox"
                                    name="enabled"
                                    checked={this.state.probeConfig.enabled}
                                    onChange={this.handleProbeConfigChange}
                                />
                                <span style={{marginLeft:'5px'}}>{i18n.translate("default_enabled")}</span>
                            </div>
                        </Col>
                        <Col sm={12} md={2} lg={2} xl={2}>
                            <label>{i18n.translate("automatic_fcm_probe_frequency")}</label>
                            <select
                                className="form-select inputStandard"
                                name="intervalHours"
                                style={this.getSelectStyle()}
                                value={this.state.probeConfig.intervalHours}
                                disabled={!this.state.probeConfig.enabled}
                                onChange={this.handleProbeConfigChange}>
                                <option value={1}>1 {i18n.translate("hours")}</option>
                                <option value={3}>3 {i18n.translate("hours")}</option>
                                <option value={6}>6 {i18n.translate("hours")}</option>
                                <option value={12}>12 {i18n.translate("hours")}</option>
                                <option value={24}>24 {i18n.translate("hours")}</option>
                            </select>
                        </Col>
                        <Col sm={12} md={3} lg={3} xl={3}>
                            <label>{i18n.translate("last_automatic_fcm_probe")}</label>
                            <div>{this.getValue(this.state.probeConfig.lastRunDate)}</div>
                        </Col>
                        <Col sm={12} md={3} lg={3} xl={3}>
                            <label>{i18n.translate("next_automatic_fcm_probe")}</label>
                            <div>{this.getValue(this.state.probeConfig.nextRunDate)}</div>
                        </Col>
                        <Col sm={12} md={2} lg={2} xl={2} style={{paddingTop:'20px'}}>
                            <button
                                style={{float:'right'}}
                                className='buttonMzateSecondary'
                                disabled={this.state.savingProbeConfig}
                                onClick={this.saveProbeConfig}>
                                {this.state.savingProbeConfig ? i18n.translate("default_processing") : i18n.translate("save")}
                            </button>
                        </Col>
                    </Row>
                    <br/><br/>
                </nav>
                <div className='bodyContent' id='bodyContent'>
                    {this.state.spinner}
                    <Table>
                        <thead className="table-dark" style={{position:'sticky',top:'0'}}>
                            <tr>
                                <th>{i18n.translate("default_service")}</th>
                                <th>{i18n.translate("default_user")}</th>
                                <th>{i18n.translate("device_id")}</th>
                                <th>{i18n.translate("app_version")}</th>
                                <th>{i18n.translate("installation_date")}</th>
                                <th>{i18n.translate("configuration_date")}</th>
                                <th>{this.getHeaderWithHelp("uninstall_date", "uninstall_date_help")}</th>
                                <th>{this.getHeaderWithHelp("app_status", "app_status_help")}</th>
                                <th>{this.getHeaderWithHelp("last_activity", "last_activity_help")}</th>
                                <th>{this.getHeaderWithHelp("inactive_minutes", "inactive_minutes_help")}</th>
                                <th>{this.getHeaderWithHelp("last_fcm_probe", "last_fcm_probe_help")}</th>
                                <th>{this.getHeaderWithHelp("last_fcm_ack", "last_fcm_ack_help")}</th>
                                <th>{this.getHeaderWithHelp("firebase_message_token", "firebase_message_token_help")}</th>
                                <th>{this.getHeaderWithHelp("default_action", "app_install_audit_actions_help")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.listAudit.map((list) => {
                                return (
                                    <tr key={list.id} style={{cursor:'pointer'}} onClick={()=>this.showAppDetail(list)}>
                                        <td>
                                            {list.tenantId} - {list.serviceName} 
                                        </td>
                                        <td>
                                            {list.fullname} - {list.username} 
                                        </td>
                                        <td>
                                            {list.deviceId} 
                                        </td>
                                        <td>
                                            {list.appVersion} 
                                        </td>
                                        <td>
                                            {list.dateInstalled} 
                                        </td>
                                        <td>
                                            {this.getValue(list.configurationDate)}
                                        </td>
                                        <td>
                                            {this.getValue(list.uninstallDate)}
                                        </td>
                                        <td>
                                            {this.getStatus(list.appStatus)}
                                        </td>
                                        <td>
                                            {this.getValue(list.lastActivityDate)}
                                        </td>
                                        <td>
                                            {this.getValue(list.inactiveMinutes)}
                                        </td>
                                        <td>
                                            {this.getValue(list.lastProbeDate)}
                                        </td>
                                        <td>
                                            {this.getValue(list.lastAckDate)}
                                        </td>
                                        <td>
                                            {this.getFirebaseToken(list.firebaseMessageToken)}
                                        </td>
                                        <td>
                                            <button
                                                className='buttonMzateSecondary'
                                                disabled={!list.deviceId || this.state.probingDeviceId === list.deviceId}
                                                onClick={(event)=>this.sendFcmProbe(list, event)}>
                                                {this.state.probingDeviceId === list.deviceId ? i18n.translate("default_processing") : i18n.translate("send_fcm_probe")}
                                            </button>
                                            <button
                                                style={{marginTop:'5px'}}
                                                className='buttonMzateSecondary'
                                                disabled={!list.deviceId || !list.firebaseMessageToken || list.appStatus === "POSSIBLE_UNINSTALL" || this.state.probingDeviceId === list.deviceId}
                                                onClick={(event)=>this.sendReactivationNotification(list, event)}>
                                                {this.state.probingDeviceId === list.deviceId ? i18n.translate("default_processing") : i18n.translate("send_reactivation_notification")}
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })} 
                        </tbody>
                    </Table>
                </div>
            </>
        )
    } 
} 

export default AppInstallAudit;
